'use strict';

//import "./css/styles.css";
import "./scss/styles.scss";

import Engine from "./components/Engine/Engine";
import cfJS from "./components/Engine/cfJS";
import "./components/Button/Button";
import "./components/Link/Link";
import "./components/CodeMirror/CodeMirror";
import "./components/Notice/Notice";
import "./components/Picklist/Picklist";
import "./components/Input/Input";
import "./components/Checkbox/Checkbox";
import "./components/Tab/Tab";
import "./components/Tooltip/Tooltip";
import "./components/Dialog/Dialog";
import "./components/Image/Image";
//with firebase
//import "./components/PushNotifications/PushNotifications";
import "./components/CurrentUser/CurrentUser";

window.engine = Engine;
window.cfJS = cfJS;